export default __webpack_public_path__ + "static/media/angle.75096b43.svg";